export default __webpack_public_path__ + "static/media/icons-lion-logo-gold.7ff5c9aa.svg";